module.exports = __webpack_public_path__ + "img/icon_glasses.4cfa266e.png";